export async function useSupabaseUserSync() {
    const supabase = useSupabaseClient();
    const { data: userData, error: userError } = await supabase.auth.getUser();
    if (userError) {
        console.error("Error fetching user data:", userError);
        return null;
    }

    return userData?.user;
}
